import { EventEmitter } from 'events';
import log from 'loglevel';
import { MessageType } from '../constants/Constants';

/**
 *
 * Created Date: 2019-05-20, 18:05:18 (zhenliang.sun)
 * Last Modified: 2019-05-20, 20:18:14 (zhenliang.sun)
 * Email: zhenliang.sun@gmail.com
 *
 * Distributed under the MIT license. See LICENSE file for details.
 * Copyright (c) 2019 vhall
 */

export default class Sender {
  constructor() {
    this.emitter = new EventEmitter();
  }

  _fire(action, data) {
    let strData = JSON.stringify(data);
    log.info(`shoot! ${action} `, strData);
    this.emitter.emit(action, strData);
  }

  add(obj) {
    this._fire(MessageType.Add, obj);
  }

  modify(obj) {
    this._fire(MessageType.Modify, obj);
  }

  remove(obj) {
    this._fire(MessageType.Remove, obj);
  }

  removeAll(obj) {
    this._fire(MessageType.RemoveAll, obj);
  }

  selected(obj) {
    this._fire(MessageType.Selected, obj);
  }

  deselected(obj) {
    this._fire(MessageType.Deselected, obj);
  }

  selectChange(obj) {
    this._fire(MessageType.SelectChanged, obj);
  }
  undo() {
    this._fire(MessageType.Undo, {});
  }
  redo() {
    this._fire(MessageType.Redo, {});
  }
}
